const REQUIRED_PATH = '/store/customer-access-center'
const SERVICES_HOST = /^([a-z0-9-]+\.)?services\.leadconnectorhq\.com$/
const LEGACY_HOST = 'backend.leadconnectorhq.com'

export const resolveApiBaseUrl = (candidate: unknown): string => {
  if (typeof candidate !== 'string' || candidate === '') return ''
  let url: URL
  try {
    url = new URL(candidate)
  } catch {
    return ''
  }
  if (url.protocol !== 'https:') return ''
  if (url.port !== '') return ''
  if (url.hostname !== LEGACY_HOST && !SERVICES_HOST.test(url.hostname)) return ''
  if (url.pathname.replace(/\/$/, '') !== REQUIRED_PATH || url.search || url.hash) return ''
  return `${url.origin}${REQUIRED_PATH}`
}

const CANONICAL_SERVICES_HOST: Record<string, string> = {
  'backend.leadconnectorhq.com': 'services.leadconnectorhq.com',
}

export const servicesRoot = (apiBaseUrl: string): string => {
  if (!apiBaseUrl) return ''
  try {
    const url = new URL(apiBaseUrl)
    return `${url.protocol}//${CANONICAL_SERVICES_HOST[url.hostname] ?? url.hostname}`
  } catch {
    return ''
  }
}

export const resolveRegionalBase = (apiBaseUrl: string, fallback: string): string => {
  const root = servicesRoot(apiBaseUrl)
  if (!root) return fallback
  try {
    return `${root}${new URL(fallback).pathname}`
  } catch {
    return fallback
  }
}
